import styled from '@emotion/styled';
import { useHeader } from './useHeader';
import { UserIcon } from 'ui/components/elements/UserIcon/UserIcon';
import LogoImg from 'ui/images/top_for_agent/logo_navy.svg';
import { mqUser } from 'utils/responsive';
import { useNavigate } from 'react-router-dom';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    height: 100%;
    padding-inline: 16px;
    background-color: #f8f9fd;
    padding: 5px 20px 5px 0;

    ${mqUser('SP')} {
        padding: 5px;
        height: var(--height-sp-header);
    }
`;

const User = styled.div`
    cursor: pointer;
    margin-left: auto;
`;

// メニュー表示時にスクロールできないようにする
const Overlay = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100vh;
    @supports (height: 100svh) {
        height: 100svh;
    }
    background-color: transparent;
    overscroll-behavior: contain;
    overflow-y: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
    touch-action: none;
    z-index: var(--tooltip);

    &:before {
        content: '';
        width: 1px;
        height: calc(100vh + 1px);
        @supports (height: 100svh) {
            height: calc(100svh + 1px);
        }
        display: flex;
    }
`;

const Popover = styled.div`
    display: inline-block;
    position: fixed;
    height: auto;
    z-index: var(--tooltip);
    pointer-events: auto;
    background-color: var(--white);
    border-radius: 4px;
    top: var(--height-pc-header);
    right: 20px;
    transform-origin: right top;
    margin-right: 8px;
    box-shadow: 0 0 4px #a9a9a9;
    visibility: ${(props: { isHidden: boolean }) => (props.isHidden ? 'hidden' : 'visible')};
    opacity: ${(props: { isHidden: boolean }) => (props.isHidden ? 0 : 1)};
    transition: opacity 0.1s ease-in;
`;

const Item = styled.div`
    padding: 10px 12px;
    font-weight: 600;
    border-bottom: 1px solid #a9a9a9;
    font-size: 14px;
    cursor: pointer;
    &:hover {
        opacity: 0.7;
    }
`;

const LogoContainer = styled.div`
    margin: 0 auto;
    height: fit-content;
    display: none;

    ${mqUser('SP')} {
        display: flex;
        justify-content: center;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        align-items: center;

        img {
            height: 45px;
            width: auto;
        }
    }
`;

export const Header: React.FC = () => {
    const { user, popoverOpen, setPopoverOpen, menuItems, onItemClick } = useHeader();
    const navigate = useNavigate();

    return (
        <Wrapper>
            <LogoContainer onClick={() => navigate('/supporter/dashboard/')}>
                <img src={LogoImg} alt="ロゴ" />
            </LogoContainer>
            <User onClick={() => setPopoverOpen(!popoverOpen)}>
                <UserIcon src={user?.icon_image} size={35} border />
            </User>
            {popoverOpen && <Overlay onClick={() => setPopoverOpen(false)} />}
            <Popover isHidden={!popoverOpen}>
                {menuItems.map((item) => (
                    <Item key={item.url} onClick={() => onItemClick(item)}>
                        {item.text}
                    </Item>
                ))}
            </Popover>
        </Wrapper>
    );
};
